export const THEME_CONFIG = {
  locale: 'en',
  currentTheme: 'dark',
  direction: 'ltr',
  navCollapsed: false,
};
